module.exports = __webpack_public_path__ + "img/close.aeecd5ac.png";